import { IS_VALID } from 'Components/frameworks/form-validator-hoc/validationStates';
import { momentFromApiDate } from 'Utils/date/apiDate';
import moment from 'moment';
import { editCriteriaFetchProposals, prepareBe } from 'Store/booking/proposals/proposals.action';
import * as pleUtils from 'Utils/ple-utils';
import { redirectToOidc } from 'Utils/uri/redirectUtils';
import { ApiException } from 'Errors/errors';
import {
  PAGE_BE_ACCOMMODATION,
  getBookingEngineUri,
} from 'Utils/booking-engine-pages/BookingPagesUtils';
import { popinsActions } from './headerPopins.reducer';
export type CriteriaForSearch = {
  search: {
    label: string;
    value: string;
    country: string;
    offsetSell: number;
    openingDates: Array<OpeningDate>;
  };
  departure: {
    duration: number | null | undefined;
    date: moment$Moment | null | undefined;
  };
  attendees: {
    adults: number;
    kids: [
      {
        birthdate: string;
        status: ValidationState;
        childcareIncluded: boolean;
      },
    ];
  };
  departureCity: {
    label: string;
    value: string;
  };
};
export const getCriteriaFromProposal = ({ resort, proposal, appContext }: any) => {
  const departureCityId =
    proposal.transports?.inbound?.travelSections?.[0]?.departure?.cityId || 'NO';
  const departureCityLabel = proposal.transports?.inbound?.travelSections?.[0]?.departure?.label;
  const criteria = {
    search: {
      label: resort.name,
      value: resort.id,
      country: resort.destination?.country,
      offsetSell: appContext.isSeller ? 0 : resort.offsetSell,
      openingDates: resort.openingDates || [],
    },
    departure: {
      duration: proposal.duration,
      date: momentFromApiDate(proposal.arrivalDate),
    },
    attendees: {
      adults: proposal.attendees.adults.length,
      kids: proposal.attendees.children.map(({ birthdate }: { birthdate: string }) => ({
        birthdate,
        status: IS_VALID,
        childcareIncluded: false,
      })),
    },
    departureCity: {
      label: departureCityLabel,
      value: departureCityId,
    },
  };
  return criteria;
};
export const searchNewProposalsNewCriteria = ({
  resort,
  criteria,
  selectedProposal,
  router,
  context,
  dispatch,
  dispatchPopin,
  setNewCriteria,
  proposalsLoaderLabel,
}: any) => {
  const { query } = router;

  if (
    criteria?.departure &&
    moment(criteria.departure.date).isBefore(moment().add(criteria.search.offsetSell, 'd'), 'day')
  ) {
    // check if valid dates
    setNewCriteria(criteria);
  }

  dispatch(
    editCriteriaFetchProposals(
      { ...criteria, isJoyView: resort.isJoyview, isUrbanOasis: resort.isUrbanOasis },
      proposalsLoaderLabel,
      context,
      query,
    ),
  )
    .then(({ proposals }) => {
      const { resort: newResort } = proposals;
      const newSelectedProposal = proposals?.proposals?.[0];

      if (proposals.errors || !selectedProposal || !proposals?.proposals?.length) {
        // no Availabilities or erros
        dispatchPopin({
          type: popinsActions.CRITERIA_CONFIRMATION_CLOSE,
        });
        dispatchPopin({
          type: popinsActions.NO_PROPOSAL_OPEN,
        });
        throw new ApiException(proposals.errors || 'No proposals found for this criteria');
      } else {
        dispatchPopin({
          type: popinsActions.CRITERIA_CONFIRMATION_CLOSE,
        });
        const { catId, openLayer, ...params } = query;
        const queryParams = {
          editCriteriaWarning: 'true',
          ...params,
          departure_city: criteria.departureCity.value,
        };
        // we have new proposals so we prepare and execute redirection to PAGE_BE_ACCOMMODATION
        const bookingUrl = getBookingEngineUri(
          PAGE_BE_ACCOMMODATION,
          proposals.proposals,
          resort,
          newSelectedProposal.id,
          queryParams,
        );
        dispatch(
          prepareBe({
            proposalId: newSelectedProposal.id,
            proposals,
            resort: newResort,
          }),
        );
        router.push(bookingUrl);
        window.scrollTo(0, 0);
      }
    })
    .catch((err) => {
      dispatchPopin({
        type: popinsActions.CLOSE_ALL_POPINS,
      });
      dispatchPopin({
        type: popinsActions.NO_PROPOSAL_OPEN,
      });

      // Redirect to oidc if the statusCode is 401
      if (pleUtils.hasAuthResponseError(err)) {
        redirectToOidc(context);
      }
    });
};
